import React, { useState, useEffect, useRef } from "react";
import { Button } from "@aws-amplify/ui-react";
import * as Auth from 'aws-amplify/auth';
import { printConsole } from './lib/utility';
import { downloadFile, uploadFile } from "./lib/common";
import logo from './logo.svg';
import './App.css';
import './LandingPage.css';
import { Outlet, Link } from "react-router-dom";
import { useNavigate, Navigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';

const Settings = ({ signOut }) => {
  let email = useRef("");
  let startingFromThisMonthChangeg = useRef("False");
  let useThirdFridayChanged = useRef("False");
  const [days, setDays] = useState("");
  const [daysOffset, setDaysOffset] = useState("");
  const [minDepth, setMinDepth] = useState("");
  const [rank, setRank] = useState("ALL");
  const [strikeMin, setStrikeMin] = useState("");
  const [strikeMax, setStrikeMax] = useState("");
  const [profitSort, setProfitSort] = useState("");
  const [excludeLeveragedEtfs, setExcludeLeveragedEtfs] = useState("");
  let defaultDayRef = useRef(30);
  let defaultDaysOffsetRef = useRef(10); 

  // NEW: additional settings
  const [useThirdFriday, setUseThirdFriday] = useState("False");          // "False" | "True"
  const [startingFromThisMonth, setStartingFromThisMonth] = useState("False"); // "False" | "True"

  const [data, setData] = useState({
    days: "", daysOffset: "", minDepth: "", excludeLeveragedEtfs: "",
    rank: "ALL", strikeMin: "", strikeMax: "", profitSort: "",
    // NEW: include in payload
    useThirdFriday: "False",
    startingFromThisMonth: "False"
  });

  const [error, setError] = useState('');
  const [hide, setHide] = useState("hidden");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  let mydata = useRef();
  let uploadResult = useRef("");

  let imageWidth = useRef(null);

  if (window.innerWidth > 694 ) {
    imageWidth.current = "33.3%";
    console.log("MainMenu : imageWidth.current = " +  imageWidth.current);
  } else {
    imageWidth.current = "90%";
    console.log("MainMenu : imageWidth.current = " +  imageWidth.current);
  }

  useEffect(() => {
    async function fetchData() {
      await executeSettingsForm();
      setLoading(false);
    }
    fetchData();
  }, []);

  // --- NEW: enforce relationships ---
  useEffect(() => {

    if (useThirdFridayChanged.current === "True") {
      useThirdFridayChanged.current = "False";
      if (useThirdFriday === "False" && startingFromThisMonth === "True") {
        setStartingFromThisMonth("False");
      }
    }
    if (startingFromThisMonthChangeg.current === "True") {
      startingFromThisMonthChangeg.current = "False";
      if (startingFromThisMonth === "True" && useThirdFriday === "False") {
        setUseThirdFriday("True");
      }
    }
    
    // If "Starting From This Month" is True, force "Use 3rd Friday" to True.
    /*if (startingFromThisMonth === "True" && useThirdFriday === "False") {
      console.log("useEffect 1 : startingFromThisMonth = " + startingFromThisMonth + ", useThirdFriday = " + useThirdFriday);
      console.log("useEffect 1 : startingFromThisMonthRef = " + startingFromThisMonthRef.current + ", useThirdFridayRef = " + useThirdFridayRef.current);
      if (startingFromThisMonth === "True" && startingFromThisMonthRef.current === "True") {
        console.log("executing useEffect 1.1");
        console.log("useEffect 1.1 : startingFromThisMonth = " + startingFromThisMonth + ", startingFromThisMonthRef = " + startingFromThisMonthRef.current);
        //startingFromThisMonthRef.current = "True";
        //useThirdFridayRef.current = "True";
        setUseThirdFriday("False");
      } else if (useThirdFriday === "False" && useThirdFridayRef.current === "True") {
        console.log("executing useEffect 1.2");
        console.log("useEffect 1.2 : useThirdFriday = " + useThirdFriday + ", useThirdFridayRef = " + useThirdFridayRef.current);
        //startingFromThisMonthRef.current = "False";
        //useThirdFridayRef.current = "False";
        setStartingFromThisMonth("False");
      } else if (useThirdFriday === "False" && useThirdFridayRef.current === "False" && startingFromThisMonth === "True" && startingFromThisMonthRef.current === "True") {
        console.log("executing useEffect 1.3");
        console.log("useEffect 1.3 : useThirdFriday = " + useThirdFriday + ", useThirdFridayRef = " + useThirdFridayRef.current);
        //startingFromThisMonthRef.current = "False";
        useThirdFridayRef.current = "True";
        setUseThirdFriday("True");
        //setStartingFromThisMonth("False");
      } else if (useThirdFriday === "False" && useThirdFridayRef.current === "False" && startingFromThisMonth === "True" && startingFromThisMonthRef.current === "False") {
        console.log("executing useEffect 1.4");
        
        setUseThirdFriday("False");
      }
    }*/
    
    //startingFromThisMonth
    /*if (useThirdFridayRef.current !== "True" && startingFromThisMonthRef.current === "True") {
      console.log("useEffect 1.4 : startingFromThisMonth = " + startingFromThisMonth + ", useThirdFriday = " + useThirdFriday);
      console.log("useEffect 1.4 : startingFromThisMonthRef = " + startingFromThisMonthRef.current + ", useThirdFridayRef = " + useThirdFridayRef.current);
      setStartingFromThisMonth("False");
    }
    if (useThirdFriday === "True" && useThirdFridayRef.current === "False") {
      console.log ( "Executing condition: useThirdFriday === True && useThirdFridayRef.current === False");
      useThirdFridayRef.current = "True";
    }
    if (useThirdFriday === "False" && useThirdFridayRef.current === "True") {
      console.log ( "Executing condition: useThirdFriday === False && useThirdFridayRef.current === True");
      useThirdFridayRef.current = "False";
    }
    if (startingFromThisMonth === "True" && startingFromThisMonthRef.current === "False") {
      console.log("Executing condition: startingFromThisMonth === True && startingFromThisMonthRef.current === False");
      startingFromThisMonthRef.current = "True";
    }
    if (startingFromThisMonth === "False" && startingFromThisMonthRef.current === "True") {
      console.log("Executing condition: startingFromThisMonth === False && startingFromThisMonthRef.current === True");
      startingFromThisMonthRef.current = "False";
    }*/
    console.log("finished useEffect 1");
    console.log("useEffect 1.end : startingFromThisMonth = " + startingFromThisMonth + ", useThirdFriday = " + useThirdFriday);
    //console.log("useEffect 1.end : startingFromThisMonthRef = " + startingFromThisMonthRef.current + ", useThirdFridayRef = " + useThirdFridayRef.current);
  }, [startingFromThisMonth, useThirdFriday]);

  useEffect(() => {
    // When Use 3rd Friday = True (whether by user or forced), set days/daysOffset to 0 and disable (handled in JSX)
    if (useThirdFriday === "True") {
      
      console.log("useEffect 2.2 : startingFromThisMonth = " + startingFromThisMonth + ", useThirdFriday = " + useThirdFriday); 
      if (days !== "0") setDays("0");
      if (daysOffset !== "0") setDaysOffset("0");
    }
    if (useThirdFriday === "False") {
      if (days === "0") setDays(data.days.toString());
      if (daysOffset === "0") setDaysOffset(data.daysOffset.toString());
    }
    // Nothing else required here for False; fields become enabled in JSX
  }, [useThirdFriday]);

  useEffect(() => {
    if (submitted) {
      let settingsJson = { ...data };

      // carry over empty fields from previously downloaded data
      if (settingsJson.days === "") settingsJson.days = mydata.current.days.toString();
      if (settingsJson.daysOffset === "") settingsJson.daysOffset = mydata.current.daysOffset.toString();
      if (settingsJson.minDepth === "") settingsJson.minDepth = mydata.current.minDepth.toString();
      if (settingsJson.excludeLeveragedEtfs === "") settingsJson.excludeLeveragedEtfs = mydata.current.excludeLeveragedEtfs.toString();
      if (settingsJson.rank === "ALL") settingsJson.rank = mydata.current.rank.toString();
      if (settingsJson.strikeMin === "") settingsJson.strikeMin = mydata.current.strikeMin.toString();
      if (settingsJson.strikeMax === "") settingsJson.strikeMax = mydata.current.strikeMax.toString();
      if (settingsJson.profitSort === "") settingsJson.profitSort = mydata.current.profitSort.toString();

      // NEW: fill-through for added fields
      if (!("useThirdFriday" in settingsJson) || settingsJson.useThirdFriday === "")
        settingsJson.useThirdFriday = mydata.current.useThirdFriday?.toString() ?? "False";
      if (!("startingFromThisMonth" in settingsJson) || settingsJson.startingFromThisMonth === "")
        settingsJson.startingFromThisMonth = mydata.current.startingFromThisMonth?.toString() ?? "False";

      (async () => {
        await uploadFile(email.current, settingsJson).then(result => {
          uploadResult.current = result === "completed the upload" ? "Successful Upload" : "Upload Failed";
          setSubmitted(false);
        });
      })();
    }
  }, [submitted, data, rank, profitSort, strikeMax, strikeMin]);

  const getUserInfo = async () => {
    try {
      await Auth.fetchAuthSession();
      const user = await Auth.fetchUserAttributes();
      email.current = await user.email;
      return "done";
    } catch (error) {
      printConsole("Error in getUserInfo: ", error);
      return "error";
    }
  };

  const listFiles = async () => {
    try {
      await printConsole("Executing listFiles");
      if (typeof (email.current) === 'undefined') {
        await getUserInfo();
      }
      await downloadFile(email.current).then(async result => {
        mydata.current = await JSON.parse(result);
        await printConsole("listFiles : downloadFile : mydata = " + JSON.stringify(mydata.current));
      });
      await setData(prev => ({ ...prev, ...mydata.current }));

      // populate state from stored values (fall back to defaults)
      setDays(mydata.current.days);
      setDaysOffset(mydata.current.daysOffset);
      setMinDepth(mydata.current.minDepth);
      setExcludeLeveragedEtfs(mydata.current.excludeLeveragedEtfs);
      setRank(mydata.current.rank);
      setStrikeMin(mydata.current.strikeMin);
      setStrikeMax(mydata.current.strikeMax);
      setProfitSort(mydata.current.profitSort);

      // NEW: populate
      setUseThirdFriday(mydata.current.useThirdFriday ?? "False");
      setStartingFromThisMonth(mydata.current.startingFromThisMonth ?? "False");
    } catch (error) {
      printConsole("Error in listFiles: ", error);
    }
  };

  const executeSettingsForm = async () => {
    await Promise.resolve(await getUserInfo())
      .then(async () => {
        if (typeof (email.current) === 'undefined') {
          await getUserInfo();
        }
        await listFiles();
      });
  };

  const handleSubmit = () => {
    uploadResult.current = "Uploading";

    // Construct settings JSON from the current state (including NEW fields)
    let settingsJson = {
      days,
      daysOffset,
      minDepth,
      excludeLeveragedEtfs,
      rank,
      strikeMin,
      strikeMax,
      profitSort,
      useThirdFriday,
      startingFromThisMonth
    };

    setData(settingsJson);
    mydata.current = settingsJson;
    setSubmitted(true);
  };

  const defaultValues = () => {
    setSubmitted(false);
    setDays(30);
    setDaysOffset(10);
    setMinDepth(10);
    setExcludeLeveragedEtfs("NO");
    setRank("ALL");
    setStrikeMin("");
    setStrikeMax("");
    setProfitSort("");

    // NEW defaults
    setUseThirdFriday("False");
    setStartingFromThisMonth("False");

    setData({
      days: 30, daysOffset: 10, minDepth: 10, excludeLeveragedEtfs: "NO",
      rank: "ALL", strikeMin: "", strikeMax: "", profitSort: "",
      useThirdFriday: "False",
      startingFromThisMonth: "False"
    });
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh'
  };
  const inputStyle = {
    margin: '10px',
    padding: '10px',
    width: '300px',
    borderRadius: '5px',
    border: '1px solid #ddd'
  };

  const buttonStyle = {
    margin: '10px',
    padding: '10px 20px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#4CAF50',
    color: 'white',
    cursor: 'pointer'
  };

  const daysFieldsDisabled = useThirdFriday === "True" || startingFromThisMonth === "True";

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            Settings
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.6)' }}>
            Configure your buy-write strategy preferences
          </p>
        </div>

        {loading ? (
          <div style={{
            padding: '12px',
            marginBottom: '16px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500'
          }}>Loading...</div>
        ) : (
          <>
            {/* Upload Status Messages */}
            {uploadResult.current === "Uploading" && (
              <div style={{
                padding: '12px',
                marginBottom: '16px',
                background: 'rgba(59, 130, 246, 0.1)',
                borderRadius: '8px',
                color: '#3b82f6',
                fontWeight: '500'
              }}>{uploadResult.current}</div>
            )}
            {uploadResult.current === "Successful Upload" && (
              <div style={{
                padding: '12px',
                marginBottom: '16px',
                background: 'rgba(16, 185, 129, 0.1)',
                borderRadius: '8px',
                color: '#10b981',
                fontWeight: '500'
              }}>{uploadResult.current}</div>
            )}
            {uploadResult.current === "Upload Failed" && (
              <div style={{
                padding: '12px',
                marginBottom: '16px',
                background: 'rgba(239, 68, 68, 0.1)',
                borderRadius: '8px',
                color: '#ef4444',
                fontWeight: '500'
              }}>{uploadResult.current}</div>
            )}

            <form id="settingsForm" name="settingsForm">
              {/* Expiration Options Panel */}
              <div className="landing-panel" style={{ marginBottom: '24px' }}>
                <div className="landing-panel-header">
                  <h2 className="landing-panel-title">📅 Expiration Options</h2>
                </div>
                <div className="landing-panel-content">

            {/* Use 3rd Friday / Starting From This Month */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Use 3rd Friday
                </label>
                <select
                  name="useThirdFriday"
                  value={useThirdFriday}
                  onChange={(e) => { setUseThirdFriday(e.target.value); useThirdFridayChanged.current="True"; uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                >
                  <option value="False">False</option>
                  <option value="True">True</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Starting From This Month
                </label>
                <select
                  name="startingFromThisMonth"
                  value={startingFromThisMonth}
                  onChange={(e) => { startingFromThisMonthChangeg.current = "True"; setStartingFromThisMonth(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                >
                  <option value="False">False</option>
                  <option value="True">True</option>
                </select>
              </div>
            </div>

            {/* Days and Days Offset */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Days to Find Next Expiration
                </label>
                <input
                  type="text"
                  id="days"
                  name="days"
                  placeholder={data.days}
                  value={days}
                  disabled={daysFieldsDisabled}
                  onChange={(e) => { setDays(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Days Offset
                  <div style={{ fontSize: '11px', fontWeight: '400', color: 'rgba(107, 114, 128, 1)' }}>
                    (if no options expiration on desired day)
                  </div>
                </label>
                <input
                  type="text"
                  name="daysOffset"
                  placeholder={data.daysOffset}
                  value={daysOffset}
                  disabled={daysFieldsDisabled}
                  onChange={(e) => { setDaysOffset(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Data Options Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">📊 Data Options</h2>
          </div>
          <div className="landing-panel-content">

            {/* Minimum Depth and Exclude Leveraged */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Minimum Depth In %
                </label>
                <input
                  type="text"
                  name="minDepth"
                  placeholder={data.minDepth}
                  value={minDepth}
                  onChange={(e) => { setMinDepth(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Exclude Leveraged ETFs
                </label>
                <select
                  name="excludeLeveragedEtfs"
                  value={excludeLeveragedEtfs}
                  onChange={(e) => { setExcludeLeveragedEtfs(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                >
                  <option value="NO">NO</option>
                  <option value="YES">YES</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Grid Options Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">⚙️ Grid Options</h2>
          </div>
          <div className="landing-panel-content">

            {/* Rank and Sort Profit */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Rank
                </label>
                <select
                  name="rank"
                  value={rank}
                  onChange={(e) => { setRank(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                >
                  <option value="ALL">ALL</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Profit Sort
                </label>
                <select
                  name="profitSort"
                  value={profitSort}
                  onChange={(e) => { setProfitSort(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                >
                  <option value="">&nbsp;</option>
                  <option value="DESC">DESC</option>
                  <option value="ASC">ASC</option>
                </select>
              </div>
            </div>

            {/* Min Strike and Max Strike */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Min Strike
                </label>
                <input
                  type="text"
                  name="strikeMin"
                  placeholder={data.strikeMin}
                  value={strikeMin}
                  onChange={(e) => { setStrikeMin(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '8px', color: 'rgba(55, 65, 81, 1)' }}>
                  Max Strike
                </label>
                <input
                  type="text"
                  name="strikeMax"
                  placeholder={data.strikeMax}
                  value={strikeMax}
                  onChange={(e) => { setStrikeMax(e.target.value); uploadResult.current = ""; }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </form>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
        <button
          onClick={handleSubmit}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(59, 130, 246, 0.3)';
          }}
        >
          Submit
        </button>

        <button
          onClick={defaultValues}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 4px 6px rgba(107, 114, 128, 0.3)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(107, 114, 128, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(107, 114, 128, 0.3)';
          }}
        >
          Default
        </button>
      </div>

      {hide !== "hidden" && <textarea style={{ marginTop: '20px' }} placeholder={error} readOnly></textarea>}
    </>
  )}
</div>
</AppLayout>
  );
};

export default Settings;